module.exports = __webpack_public_path__ + "media/images/emblems/Raperswilen-a12b21c43bcf46733c84b18a3a2b901d.gif";